import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as productApi from '../../lib/api/product';

const [VIEW_PRODUCT, VIEW_PRODUCT_SUCCESS, VIEW_PRODUCT_FAILURE] =
  createRequestActionTypes('product/VIEW_PRODUCT');
export const viewProduct = createAction(VIEW_PRODUCT, (id) => id);
const viewProductSaga = createRequestSaga(VIEW_PRODUCT, productApi.getProduct);

const UNLOAD_PRODUCT = 'product/UNLOAD_PRODUCT';
export const unloadProduct = createAction(UNLOAD_PRODUCT);

const SET_PRODUCT = 'product/SET_PRODUCT';
export const setProduct = createAction(SET_PRODUCT, (product) => product);

export function* productSaga() {
  yield takeLatest(VIEW_PRODUCT, viewProductSaga);
}

const initialState = {
  product: null,
  error: null,
};

const product = handleActions(
  {
    [VIEW_PRODUCT_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      product: data.info,
    }),
    [VIEW_PRODUCT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [UNLOAD_PRODUCT]: () => initialState,
    [SET_PRODUCT]: (state, { payload: product }) => ({
      ...state,
      product: product,
    }),
  },
  initialState,
);

export default product;
